import {FC, useEffect, useState} from 'react'
import {Group} from '../../../../../../services/cellcast.v2.types'
import {Col, Form, Modal, OverlayTrigger, Row, Spinner, Tooltip} from 'react-bootstrap'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {ReactSortable} from 'react-sortablejs'
import WSButton from '../../../../../../_metronic/helpers/components/WSButton/WSButton'
import {useUpdateContactFieldsMutation} from '../../../../../../services/cellcast.v2'
import {toast} from 'react-toastify'

type SettingFieldsProps = {
  id: string
  fields: string[]
  show: boolean
  handleClose: () => void
  callbackFn: () => void
}

const SettingFields: FC<SettingFieldsProps> = ({
  id,
  fields: groupFields,
  show,
  handleClose,
  callbackFn,
}) => {
  const [fields, setFields] = useState<string[]>([])

  const [updateFields, {isLoading}] = useUpdateContactFieldsMutation()
  useEffect(() => {
    if (groupFields) {
      setFields([...groupFields])
    }
  }, [groupFields])

  const updateFieldHandle = () => {
    updateFields({
      id,
      fields,
    })
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)

          if (callbackFn) {
            callbackFn()
          }
        } else if ('error' in res) {
          const errObj = res.error as any
          if (errObj.data.message) {
            toast.error(errObj.data.message)
          } else {
            toast.error(res.error)
          }
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
  }

  return (
    <Modal
      id='kt_modal_create_app'
      tabIndex={1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-700px'
      className='vh-100'
      show={show}
      backdrop='static'
      onHide={handleClose}
    >
      <div className='scroll-x'>
        <div className='modal-header'>
          <h2 className='fs-2'>Setting Fields</h2>
          <div
            className='btn btn-icon btn-sm'
            onClick={() => {
              handleClose()
            }}
          >
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body py-lg-5 px-lg-5 border-bottom'>
          <Row>
            <Col md={12}>
              {fields.length > 0 && (
                <Row>
                  <Col md={10}>
                    <ReactSortable
                      tag='ul'
                      list={fields.map((el, index) => {
                        return {id: index + 1, name: el}
                      })}
                      setList={(evt) => {
                        const newFields = evt.map((el) => {
                          return el.name
                        })
                        setFields(newFields)
                      }}
                      className='list-group'
                    >
                      {fields.map((item, index) => (
                        <li key={index} className='ms-5 list-group-item' style={{paddingLeft: 0}}>
                          <div className='col-md-6 col-lg-11'>
                            <div
                              style={{
                                position: 'absolute',
                                top: '50%',
                                left: '-20px',
                                transform: 'translateY(-50%)',
                                padding: '0.60rem',
                                cursor: 'grab',
                                backgroundColor: '#F5F8FA',
                                color: '#fffff',
                                borderTopLeftRadius: '0.325rem',
                                borderBottomLeftRadius: '0.325rem',
                              }}
                            >
                              <i className='bi bi-grip-vertical drag-handle'></i>
                            </div>

                            <div key={index} className='input-delete'>
                              <input
                                value={item}
                                type='text'
                                placeholder={`Field ${index}`}
                                name={'field'}
                                onChange={(e) => {
                                  const tmpFields = [...fields]
                                  tmpFields[index] = e.target.value
                                  setFields(tmpFields)
                                }}
                                className='form-control form-control-sm'
                              />

                              {/* <OverlayTrigger
                                placement='right'
                                overlay={
                                  <Tooltip>
                                    Deleting this field will not permanently remove the data
                                  </Tooltip>
                                }
                              >
                                <i
                                  onClick={() => {
                                    const tmpFields = [...fields].filter(
                                      (el, fIndex) => index !== fIndex
                                    )
                                    setFields(tmpFields)
                                  }}
                                  className='bi bi-x'
                                ></i>
                              </OverlayTrigger> */}
                            </div>
                          </div>
                        </li>
                      ))}
                    </ReactSortable>
                  </Col>
                </Row>
              )}
              <Row>
                <Col md={8}>
                  <WSButton
                    className='mt-5 btn btn-sm  btn-light btn-light-primary text-primary text-hover-white me-2 w-100'
                    onClick={() => {
                      const tmpField = [...fields]
                      tmpField.push('')
                      setFields(tmpField)
                    }}
                  >
                    <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-1' />
                    Add Field
                  </WSButton>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

        <div className='modal-footer d-flex justify-content-end pt-0'>
          <button className='btn btn-md gray_bg_purple' type='button' onClick={handleClose}>
            Cancel
          </button>

          <button
            type='submit'
            disabled={isLoading}
            onClick={() => updateFieldHandle()}
            className='btn btn-md btn-primary ml-2'
          >
            {isLoading ? <Spinner size='sm' animation='grow' /> : 'Save'}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default SettingFields
